module.exports = __webpack_public_path__ + "static/media/tripadvisor.07c148f0.ico";